import React from 'react';
import { ConfirmEmailChange } from './components/confirm-email-change';
import { useSelector } from 'react-redux';
import { selectSettings } from 'app/slice/selectors';
import { mediaBaseUrl } from 'utils/api/endpoints';

const ConfirmEmailChangePage = () => {
  const settings = useSelector(selectSettings);
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-gray-50">
      <div className="max-w-md w-full space-y-8 bg-white dark:bg-transparent p-8 rounded-2xl">
        <div className="text-center">
          <img
            src={`${mediaBaseUrl}/site/${settings?.options?.logo}`}
            alt={settings?.site_name}
            className="max-w-[110px] mx-auto mb-4"
          />
          <h2 className="text-2xl font-semibold tracking-tight text-gray-900 mb-2">
            Confirm Email Change
          </h2>
        </div>
        <ConfirmEmailChange />
      </div>
    </div>
  );
};

export default ConfirmEmailChangePage;
